export default __webpack_public_path__ + "static/media/88.d4b2105a.png";